<template>
    <v-card>
        <v-navigation-drawer
        v-model="right_drawer"
        app dark      
        right
        width="400px"
        >
           <template v-slot:prepend>
              <v-list-item >
                 <v-list-item-icon>
                      <v-icon> mdi-plus-circle </v-icon>
                 </v-list-item-icon>
				 <v-list-item-content>
                     <v-list-item-title class="font-weight-bold">POI Creation</v-list-item-title>
                 </v-list-item-content>
                 <v-btn
                 icon
                 @click.stop="close_right_sidebar" 
                 >
                    <v-icon>mdi-chevron-right</v-icon>
                 </v-btn>
              </v-list-item>
              <v-list-item >
                  <v-breadcrumbs large dark :items="b_items">
                      <template v-slot:divider>
                          <v-icon>mdi-forward</v-icon>
                      </template>
                  </v-breadcrumbs>
              </v-list-item > 
           </template>
           <v-divider></v-divider>
           <template>
              <v-form
              class="mx-2"
              ref="form"
              v-model="valid"
              lazy-validation
              >
                 <v-text-field
                 v-model="title"
                 :counter="100"
                 :rules="titleRules"
                 required>
                    <template #label>
                        <span class="red--text"><strong>* </strong></span>Title of the POI
                    </template>
                 </v-text-field>
                 <v-text-field
                 v-model="latitude"
                 :rules="latitudeRules"
                 required>
                     <template #label>
                         <span class="red--text"><strong>* </strong></span>Latitude (in WGS-84 reference system)
                     </template>
                 </v-text-field>
                 <v-text-field
                 v-model="longitude"
                 :rules="longitudeRules"
                 required>
                    <template #label>
                        <span class="red--text"><strong>* </strong></span>Longitude (in WGS-84 reference system)
                    </template>
                 </v-text-field>
                 <v-text-field
                 v-model="activation_range"
                 :rules="activationRangeRules"
                 required>
                     <template #label>
                         <span class="red--text"><strong>* </strong></span>Activation Range (in meters)
                     </template>
                 </v-text-field>
                 <v-textarea
                 name="input-7-1"
                 label="PΟΙ Description"
                 v-model="description"
                 hint="Insert something about the POI">
				 </v-textarea>
                 <v-checkbox
                 v-model="create_qr_code"
                 label="Create QR code for the POI">
				 </v-checkbox>
                 <v-select
                 v-model="file_type"
                 :items="file_types"
                 label="File Type"
                 style="max-width: 250px;">
				 </v-select>
                 <v-file-input v-if="file_type=='Video'"   v-model="video_file" :rules="videoRules"  prepend-icon="mdi-video" chips show-size accept="video/*" label="POI Video"></v-file-input>
                 <v-file-input v-if="file_type=='Image'" v-model="image_file" :rules="imageRules"  prepend-icon="mdi-camera" chips show-size accept="image/*" label="POI Image"></v-file-input>
                 <v-file-input v-if="file_type=='3D Model'" @change="model_uploaded" v-model="three_d_model_file" :rules="modelRules"  prepend-icon="mdi-video-3d" chips show-size accept=".zip" label="zip containing .obj and .mtl files"></v-file-input>
                 <v-checkbox
                 v-model="create_quiz_now"
                 label="Create now the quiz for this POI">
	             </v-checkbox>
              
			     <div v-if="create_quiz_now">
                    <v-text-field
                    :rules="scoreRules"
                    class="mt-2"
                    v-model="score"
                    label="Quiz Score"
                    max="10"
                    min="1"
                    step="1"
                    style="width: 125px"
                    type="number"
                    @keydown="false">
                       <template #label>
                            <span class="red--text"><strong>* </strong></span>Quiz Score
                       </template>
                    </v-text-field>
                    <v-textarea
                    :rules="questionRules"
                    name="input-7-1"
                    v-model="question"
                    hint="Insert here the quiz question"
                    :counter="200">
                        <template #label>
                            <span class="red--text"><strong>* </strong></span>Quiz Question
                        </template>
                    </v-textarea>
                    <v-select
                    v-model="question_type"
                    :items="question_types"
                    label="Question Type"
                    style="max-width: 250px;">
					</v-select>

                    <div v-if="question_type=='Multiple choice'">
                        <v-text-field  v-for= "answer in answers" :key=answer.index 
                        :append-outer-icon="answer.index > 2 ? 'mdi-minus' : ''"
                        @click:append-outer="remove_answer(answer.index)"
                        v-model="answer.value"
                        :counter="200"
                        :rules="answerRules"
                        required >
                           <template #label>
                                <span class="red--text"><strong>* </strong></span>Answer {{answer.index}}
                           </template>
                        </v-text-field>
                        <v-btn small color="success"
                        @click="add_answer">
                            <v-icon small left>mdi-plus</v-icon>
                             Add Answer
                        </v-btn>
                        <v-select
                        class="mt-2"
                        v-model="correct_answer"
                        :items=" potential_answers_choice"
                        append-icon="mdi-thumb-up"
                        menu-props="auto"
                        outlined
                        required
                        :rules="correctAnswerRules">
                            <template #label>
                                <span class="red--text"><strong>* </strong></span>Select the Correct Answer
                            </template>
                        </v-select>
                    </div>
					<div v-else>
                        <v-select
                        class="mt-2"
                        v-model="correct_answer"
                        :items="yes_no_potential_answers_choice"
                        append-icon="mdi-thumb-up"
                        menu-props="auto"
                        outlined
                        required
                        :rules="correctAnswerRules">
                            <template #label>
                                <span class="red--text"><strong>* </strong></span>Select the Correct Answer
                            </template>
                        </v-select>
                    </div>
					<v-textarea
                    label="Correct Answer Explanation"
                    v-model="explanation"
                    hint="Insert here the explanation for the Correct Answer"
                    :counter="500">
					</v-textarea>
                 </div>
                 <v-btn
                 @click="store_poi"
                 :loading="waiting_for_storage"
                 :disabled="waiting_for_storage"
                 color="success"
                 class="mr-6 white--text">
                      <v-icon left dark>mdi-content-save</v-icon> Store POI
                 </v-btn>
                 <v-btn
                 color="error"
                 class="mr-6"
                 @click="reset">
                    <v-icon left dark>mdi-eraser</v-icon> Reset Form
                 </v-btn>
              </v-form>
           </template>
        </v-navigation-drawer>
        <v-snackbar
        v-model="instructions_snackbar"
        :timeout= "instructions_snackbar_timeout"
        :multi-line="instructions_snackbar_multiline">
        Click on map in order to set automatically latitude and longitude. Alternatively you can set manually the coordinates.  
            <v-btn
            color="red"
            text
            @click="instructions_snackbar = false">
            Close
            </v-btn>
        </v-snackbar>

        <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :color="snackbar_color"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'">
        {{ snackbar_text }}
           <v-btn
           dark
           text
           @click="snackbar = false"
           >
           Close
           </v-btn>
        </v-snackbar>

        <v-snackbar
        v-model="file_snackbar"
        :bottom="file_snackbar_y === 'bottom'"
        :color="file_snackbar_color"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="file_snackbar_y === 'top'"
        :vertical="mode === 'vertical'">
        {{ file_snackbar_text }}
           <v-btn
           dark
           text
           @click="file_snackbar = false">
           Close
           </v-btn>
        </v-snackbar>

        <v-overlay light :value="overlay" z-index=1000 opacity="0.1">
             <v-progress-circular
             :rotate="-90"
             :size="100"
             :width="15"
             :value="file_upload_percentage"
             color="indigo">
             {{ file_upload_percentage }}
             </v-progress-circular>
        </v-overlay>
    </v-card>
</template>

<script>
    //var JSZip = require('../JSZip');
    import { componentBus } from '../main';
    import axios from 'axios';
    import {  APIS_BASE_URL } from '../constants';
    import JSZip from 'jszip' 
    export default {
        name: 'PoiAddition',
        data: function () {
            return {
		// Quiz relevant variables		
		correct_answer: null,
		question: null,		
        score: 1,
		create_quiz_now: false,
		question_types: ['Multiple choice','Yes/No'],
        question_type: 'Multiple choice',
		answers: [{index:1, value: null},{index: 2, value: null}],
		potential_answers_choice: [{ text: 'Answer 1', value: 1},{ text: 'Answer 2', value: 2}],
		yes_no_potential_answers_choice: [{ text: 'No', value: 1},{ text: 'Yes', value: 2}],
		explanation: null,
		

		
		
		instructions_snackbar: true,
        instructions_snackbar_timeout: 0,
        instructions_snackbar_multiline: true,

        activation_range: null,
        overlay: false,
        file_upload_percentage: null,

        file_upload_config : {
        headers: { 'Content-Type': 'multipart/form-data'},
        onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            //alert(percentCompleted);
            this.file_upload_percentage = percentCompleted;
        }

        },      

         b_items: [
        {
          text: 'Project',
          disabled: false,
          to: ''
        },
        {
          text: 'POI Addition',
          disabled: true,
          to: ''
          //href: 'breadcrumbs_link_1',
        }
       
      ],      

        file_types: ['No File','Image','Video','3D Model'],
        file_type: 'No File',
        //video_input_modes: ['Link','File'],
        //video_input_mode: 'Link',


        snackbar_color: '',
        mode: '',
        snackbar: false,
        snackbar_text: '',
        timeout: 4000,
        x: null,
        y: 'top',


        file_snackbar_color: '',
        file_snackbar: false,
        file_snackbar_text: '',
        file_snackbar_y: 'bottom',

      create_qr_code: false,
      waiting_for_storage: false,
      image_file: null,
      video_file: null,
      three_d_model_file: null,
      //video_link: null,
      //pick_a_point: false,
      entity_type_image: "nextGen_logo-simple.png",
      right_drawer: true,


      project_uuid: null,
      project_title: null,
      project_longitude: null,
      project_latitude: null,
      project_range: null,
      project_has_image: null,
      project_description: null,
	  poi_uuid: null,



      valid: true,
      title: '',
      titleRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 100) || 'Name must be less than 10 characters',
      ],
     
      latitude: null,
      latitudeRules: [
        v => !!v || 'Latitude is required (in WGS-84 reference system)',
		v => /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/.test(v) || 'Latitude should be a Real Number (in WGS-84 reference system)',
		// because we removed circle from project
        //v =>  this.calcCrow(this.project_latitude,this.project_longitude,v, this.longitude) * 1000< this.project_range || 'POI should be inside the circle',    
      ],
      longitude: null,
      longitudeRules: [
        v => !!v || 'Longitude is required (in WGS-84 reference system)',
		v => /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/.test(v) || 'Longitude should be a Real Number (in WGS-84 reference system)',
		// because we removed circle from project
        //v =>  this.calcCrow(this.project_latitude,this.project_longitude,this.latitude, v) * 1000< this.project_range || 'POI should be inside the circle',
      ],
       imageRules: [
        v => (!!v  && this.file_type=='Image') || 'Image is required',   
      ],
       videoRules: [
        v => (!!v  && this.file_type=='Video') || 'Video is required',   
      ],
       modelRules: [
        v => (!!v  && this.file_type=='3D Model') || '3D Model is required',   
	  ],
	 
      activationRangeRules: [
        v => !!v || 'Activation Range is required (in meters)',
		//v => /^[1-9]\d+$/.test(v) || 'Range should be a Positive Integer',
		v => /^[1-9][0-9]*$/.test(v) || 'Activation Range should be a Positive Integer (in meters)',
      ], 
     
      scoreRules: [
        v => !!v || 'Score is required',
      ],
	  questionRules: [
       v => !!v || 'This field is required',
       v => (v && v.length <= 200) || 'The question must be less than 200 characters',
       
      ],
	  answerRules: [
        v => !!v || 'This field is required',
        v => (v && v.length <= 200) || 'Answers must be less than 200 characters',
        ],

      correctAnswerRules:  [
       v => !!v || 'This field is required'
       
       
      ],
      select: null,
    
      description: ''
      
                
            };
        },

       watch: {
    longitude: function (val) {
      console.log(val);
      this.$refs.form.validate();
    },
    latitude: function (val) {
      console.log(val);
      this.$refs.form.validate();
    }

   
  },



        computed: {
            
        },
        methods: {

       // store quiz if user desires
	   store_quiz()
        {
        let store_quiz_url_query=APIS_BASE_URL+"/quiz/";
        let encoded_store_quiz_url_query= encodeURI(store_quiz_url_query);
        var payload = {
          answers: this.question_type=="Multiple choice" ?  this.answers.map(  (item) => item.value) : ["No","Yes"],
          score: this.score,
          question: this.question,
          correct_answer: this.correct_answer,
          explanation: this.explanation,
          published: true,
          created_by: "aaabbbccc",
          relevant_poi: this.poi_uuid,
          question_type: this.question_type=="Multiple choice" ? 1 : 2
        }
        axios.post(encoded_store_quiz_url_query, payload,
        {
        headers: { 'Content-Type' : 'application/json'}
        }).then(response => {
        if (response.status == "200" || response.status == "201" ) {
        payload.id=response.data.id;
        payload.uuid=response.data.quiz_uuid;
	    payload.relevant_project= this.relevant_project;
		payload.range= this.activation_range;
		payload.focus_on_pin=false;
        componentBus.$emit('newly_created_quiz', payload);
		this.waiting_for_storage=false;
        this.snackbar_color="success";
        this.snackbar_text="The POI and Quiz have been successfully stored!"
        this.snackbar=true;
        this.reset();
        }
        else {
        this.waiting_for_storage=false;
        this.snackbar_color="error";
        this.snackbar_text="Problem with the Quiz creation..."
        this.snackbar=true;
        }
        this.reset();
        })
        .catch(error => {
        console.log(error);
        this.waiting_for_storage=false;
        this.snackbar_color="error";
        this.snackbar_text="Problem with the Quiz creation..."
        this.snackbar=true;
        });
        },

	   remove_answer(answer_index)
        {
         this.answers.splice(answer_index-1,1);
         this.potential_answers_choice.splice(answer_index-1,1);


         for (let i = answer_index-1; i < this.answers.length; i++) {
          this.answers[i].index=i+1;
         }

         for (let i = answer_index-1; i < this.potential_answers_choice.length; i++) {
          this.potential_answers_choice[i].text="Answer "+(i+1);
          this.potential_answers_choice[i].value=(i+1);

         }

        
      
        },		

      add_answer()
        {
        let previous_answers_counter= this.answers.length;
        this.answers.push({index: previous_answers_counter+1, value: null});
        this.potential_answers_choice.push({text: "Answer "+(previous_answers_counter+1), value: (previous_answers_counter+1)  });

        },  


      model_uploaded()
      {
       
       let obj_file_counter=0;
       if(this.three_d_model_file)
       { 
        JSZip.loadAsync(this.three_d_model_file).then( (zip) => {
        Object.keys(zip.files).forEach( (filename) => {
        //console.log(filename);
        if( filename.split('.').pop() =='obj')  obj_file_counter++;   
        //console.log(filename.split('.').pop());
        // zip.files[filename].async('string').then(function (fileData) {
        //  console.log(fileData) // These are your file contents      
        //  })
        })
        if(obj_file_counter!= 1) //alert("it contains .obj file"); else alert("it does not contain it");
        {
        this.three_d_model_file= null;
        this.snackbar_color="error";
        this.snackbar_text="The 3D Model compressed zip file should contain one .obj file!";
        this.snackbar=true;

        }
        })
        
       }
      

      },

      fetch_project_details()
      {    
        var get_project_url=APIS_BASE_URL+"/projects/"+this.project_uuid+"/";
        var get_project_url_encoded= encodeURI(get_project_url);
   
        axios.get(get_project_url_encoded)
                    .then(response => {
                    this.project_title=response.data.title;
                    this.project_longitude=response.data.point.coordinates[0];
                    this.project_latitude=response.data.point.coordinates[1];
                    //this.project_range=response.data.range;  because we removed range from project
                    this.project_has_image=response.data.has_image;
                    this.project_description=response.data.description;
                    //let payload={};
                    //payload["point_uuid"]= this.project_uuid;
                    //payload["relevant_project"]= this.project_uuid;
                   // componentBus.$emit('set_map_view', payload);


                        
                    })
                    .catch(error => console.log(error));
      },  
       //converts numeric degrees to radians
       toRad(value)
       {
        return value * Math.PI / 180;

       },

       // distance calculation as the crow flies in kilometers
       calcCrow(lat1, lon1, lat2, lon2)
       {
        var R= 6371; //km
        var dLat= this.toRad(lat2-lat1);
        var dLon= this.toRad(lon2-lon1);
        var lat1_rad= this.toRad(lat1);
        var lat2_rad= this.toRad(lat2);
        var a= Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1_rad) * Math.cos(lat2_rad);
        var c= 2* Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        var d= R*c;
        return d;
        
       },
      



        store_poi()
        {
         
         
          let valid= this.$refs.form.validate();
          //let video_link= (this.file_type=='Video' && this.video_input_mode=='Link') ? this.video_link : null;
          let video= (this.file_type=='Video') ? this.video_file : null;
          let image= (this.file_type=='Image') ? this.image_file : null;
          let model= (this.file_type=="3D Model") ? this.three_d_model_file: null;
          let multimedia_type=null;
          //if(video_link!=null) multimedia_type= 3;
          if(video!=null) multimedia_type=2;
          else if(image!=null) multimedia_type=1;   
          else if(model!=null) multimedia_type=3;
          else multimedia_type= 0;


          if( valid)    
          {
           this.waiting_for_storage=true;
           let store_poi_url_query=APIS_BASE_URL+"/pois/";
           let encoded_store_poi_url_query= encodeURI(store_poi_url_query);
           var payload = {
					title: this.title,
					activation_range: this.activation_range,
                    point: {
                      type: "Point",
                      coordinates: [ parseFloat(this.longitude), parseFloat(this.latitude)]
                    },
                    description: this.description,
                    created_by: "aaabbbccc",
                    relevant_project: this.project_uuid,
                    //video_link: video_link,
                    multimedia_type: multimedia_type
                   
                }
                 
                

           
           axios.post(encoded_store_poi_url_query, payload,
                    {
                     headers: { 'Content-Type' : 'application/json'}
                               
                        }).then(response => {
                            if (response.status == "200" || response.status == "201" ) {

                               

                               // Store also QR code
                               if(this.create_qr_code) 
                               {
                                 console.log('now i am storing qr code');
                                let create_qr_code_url_query=APIS_BASE_URL+"/pois/"+response.data.poi_uuid+"/qr_code/";
                                let encoded_create_qr_code_url_query= encodeURI(create_qr_code_url_query);
                                axios.post(encoded_create_qr_code_url_query, {},{
                                
                               
                        }).then(response => {
                                //alert("ok created");
                                console.log(response.status);
                                });

                               }
                               this.poi_uuid=response.data.poi_uuid;
							   payload.uuid=response.data.poi_uuid;
							 
                               componentBus.$emit('newly_created_poi', payload);
                               componentBus.$emit('destroy_temporary_pin', true);
                              if(image==null && video==null && model==null)
                               {
							   if(!this.create_quiz_now) {
                               this.waiting_for_storage=false;
                               this.snackbar_color="success";
                               this.snackbar_text="The POI has been successfully stored!"
                               this.snackbar=true;
                               this.reset();
							   }
							   else this.store_quiz();
                               
                               
                               }

                               

                               //now store the file as well.....
                               if(image!=null) 
                               {
                                this.file_upload_percentage=0;
                                this.overlay=true;
                                
                                let upload_image_url=APIS_BASE_URL+"/pois/"+response.data.poi_uuid+"/image/";
                                let upload_image_encoded_url= encodeURI(upload_image_url);
                                let formData = new FormData();
                                formData.append('file', image);

                                axios.post( upload_image_encoded_url,
                                 formData,
                                 //{
                                 //headers: { 'Content-Type': 'multipart/form-data'}
                                 //}
                                 this.file_upload_config
                                ).then( (image_upload_response) =>{

                                if (image_upload_response.status == "201" )
                                 {
									this.overlay=false;
									if(!this.create_quiz_now) {
                                    this.waiting_for_storage=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The POI has been successfully stored!"
                                    this.snackbar=true;
                                    this.reset();
									}
									else this.store_quiz();
                                  
                                 }
                                else
                                 {
                                  console.log('FAILURE with image upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with POI image storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   console.log('FAILURE with image upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with POI image storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                               else if(video!=null) 
                               {
                                this.file_upload_percentage=0;
                                this.overlay=true;
                                let upload_video_url=APIS_BASE_URL+"/pois/"+response.data.poi_uuid+"/video/";
                                let upload_video_encoded_url= encodeURI(upload_video_url);
                                let formData = new FormData();
                                formData.append('file', video);

                                axios.post( upload_video_encoded_url,
                                 formData,
                                 //{
                                 //headers: { 'Content-Type': 'multipart/form-data'}
                                 //}
                                 this.file_upload_config
                                ).then( (video_upload_response) =>{

                                if (video_upload_response.status == "201" )
                                   {
                                    this.overlay=false;
									if(!this.create_quiz_now) {
                                    this.waiting_for_storage=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The POI has been successfully stored!"
                                    this.snackbar=true;
                                    this.reset();
									}
									else this.store_quiz();
                                    //payload.id=response.data.id;
									//payload.uuid=response.data.poi_uuid;
									//payload.range= this.activation_range;
                                  //  componentBus.$emit('newly_created_poi', payload);
                                   // componentBus.$emit('destroy_temporary_pin', true);
                                   }
                                   //console.log('SUCCESS with video upload!!');
                                else
                                 {
                                  console.log('FAILURE with video upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with POI video storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   console.log('FAILURE with video upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with POI video storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                               else if(model!=null) 
                               {
                                this.file_upload_percentage=0;
                                this.overlay=true;
                                let upload_model_url=APIS_BASE_URL+"/pois/"+response.data.poi_uuid+"/3dmodel/";
                                let upload_model_encoded_url= encodeURI(upload_model_url);
                                let formData = new FormData();
                                formData.append('file', model);

                                axios.post( upload_model_encoded_url,
                                 formData,
                                 //{
                                 //headers: { 'Content-Type': 'multipart/form-data'}
                                 //}
                                 this.file_upload_config
                                ).then( (model_upload_response) =>{

                                if (model_upload_response.status == "201" )
                                   {
                                    this.overlay=false;
									if(!this.create_quiz_now) {
                                    this.waiting_for_storage=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The POI has been successfully stored!"
                                    this.snackbar=true;
                                    this.reset();
									}
									else this.store_quiz();
                                   // payload.id=response.data.id;
									//payload.uuid=response.data.poi_uuid;
									//payload.range= this.activation_range;
                                   // componentBus.$emit('newly_created_poi', payload);
                                   // componentBus.$emit('destroy_temporary_pin', true);
                                   }
                                   //console.log('SUCCESS with video upload!!');
                                else
                                 {
                                  console.log('FAILURE with model upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with POI 3D Model storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   console.log('FAILURE with 3D Model upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with POI 3D Model storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                             
                               
                    
                            }
                            else {
                      
                                this.waiting_for_storage=false;
                                this.snackbar_color="error";
                                this.snackbar_text="Problem with the POI storage..."
                                this.snackbar=true;
                            }
                            //this.reset();
                    })
                    .catch(error => {
                        console.log(error);
                        //alert("something went wrong"+ error);
                        this.waiting_for_storage=false;
                        this.snackbar_color="error";
                        this.snackbar_text="Problem with the POI storage..."
                        this.snackbar=true;
                    });


 
          }
          //this.close_right_sidebar ();

        },

        
       /*
        pick_point()
         {
          this.pick_a_point= !this.pick_a_point;
      
          componentBus.$emit('pick_a_point', this.pick_a_point);

         },
       */

         
      reset () {
        this.$refs.form.reset();
        componentBus.$emit('destroy_temporary_pin', true);
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

            close_right_sidebar () {
            this.right_drawer = false;
            componentBus.$emit('destroy_temporary_pin', true);

      }

           
        },
        mounted() {
	
          componentBus.$emit('pick_a_point', true);
          componentBus.$emit('poi_addition_update_navigation_bar', true);


          this.project_uuid= this.$route.query.project_uuid;

          this.b_items[0]['to']='project_edit?uuid='+this.project_uuid;
          this.fetch_project_details();

          componentBus.$on('selected_point_coordinates', (poi_point_coordinates) => {
              //if(this.pick_a_point)
                //{
				/*	
                let dist= this.calcCrow(this.project_latitude,this.project_longitude,poi_point_coordinates.lat,poi_point_coordinates.lng);
               
                if(dist * 1000>=this.project_range) console.log("einai ekso");
                else console.log("einai mesa");
                */
                
                this.latitude=poi_point_coordinates.lat;
                this.longitude=poi_point_coordinates.lng;
                //this.pick_a_point= !this.pick_a_point;
               // }
            });
    
           
        },
        destroyed() {
            componentBus.$emit('stop_picking_point', true);
            componentBus.$off('selected_point_coordinates');
            componentBus.$emit('destroy_temporary_pin', true);
   
        }
    };
</script>

<style scoped>
   
</style>
